import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowDown",
  "use": "icon-arrowDown-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowDown\"><path d=\"M16 20.571 29.257 8.457c.686-.686 1.6-.686 2.286 0s.686 1.6 0 2.057l-14.4 13.029c-.229.229-.686.457-1.143.457s-.914-.229-1.143-.457L.457 10.514c-.686-.686-.686-1.6 0-2.057.686-.686 1.6-.686 2.286 0L16 20.571z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol